import React, { createRef } from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  FloatButton,
  Tooltip,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  Collapse,
  ColorPicker,
  DatePicker,
  Tag,
  Rate,
  Radio,
  message
} from 'antd';
import { QRCodeCanvas } from 'qrcode.react';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  QrcodeOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
import Resizer from 'react-image-file-resizer';
import slugify from 'slugify';
import dayjs from 'dayjs';
import { deleteExperience } from 'src/redux/actions/experience';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const StyledTable = styled(Table)``;
const Cards = styled(Card)`
  :where(.css-dev-only-do-not-override-133wgew).ant-card .ant-card-body {
    padding-left: 0px !important;
    padding-bottom: 3em !important;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
  .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
    padding: 11px 19px !important;
    background-color: red !important;
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

const RatingWithNA = ({ value, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75em', flexWrap: 'wrap' }}>
    <Rate
      count={4}
      value={value === 5 ? 0 : (value || 0)}
      onChange={val => onChange(val || 0)}
      tooltips={['Poor', 'Fair', 'Good', 'Excellent']}
    />
    <Button
      size="small"
      type={value === 5 ? 'primary' : 'default'}
      style={{ borderRadius: '2em', fontWeight: 600, minWidth: '3.5em' }}
      onClick={() => onChange(value === 5 ? 0 : 5)}
    >
      N/A
    </Button>
  </div>
);

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}
class ExperienceFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainExperienceImage1: undefined
  };
  componentDidMount = () => {
    if (this.props.editExperience) {
      this.setState({
        mainExperienceImage1: this.props.editExperience.mainExperienceImage1
      });
    }
  };

  handleMainExperienceImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainExperienceImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === 'Add ') {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === 'Add ') {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ''
    ) {
      descriptions.push({ value: 'Add ' + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    return (
      <Form layout="vertical">
        <Row
          gutter={24}
          style={{ padding: '3em', paddingTop: '0em', paddingBottom: '0em' }}
        >
          {/* Timestamp */}
          <Col span={6}>
            <FormItem label={<span>Timestamp</span>}>
              {this.props.form.getFieldDecorator('timestamp', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.timestamp)
                  : undefined
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder="Timestamp"
                  size="large"
                />
              )}
            </FormItem>
          </Col>

          {/* Score */}
          {/* <Col span={6}>
            <FormItem label="Score">
              {this.props.form.getFieldDecorator("score", {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.score
                  : null,
                rules: [{ required: true, message: "Score is required" }],
              })(
                <InputNumber
                  min={0}
                  max={10}
                  style={{ width: "100%" }}
                  placeholder="Enter a score out of 10"
                  size="large"
                />
              )}
            </FormItem>
          </Col> */}
          <Col span={6} style={{ display: 'none' }}>
            {' '}
            <FormItem label={<span>Assign To</span>}>
              {this.props.form.getFieldDecorator('access', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.access
                  : this.props.siteSelected
              })(
                <Select
                  size="large"
                  // mode="multiple"
                  showSearch
                >
                  {/* <Option key="Admin" value="Admin">
                  Admin
                </Option> */}
                  {this.props.sites.map(site => (
                    <Option key={site._id} value={site._id}>
                      {site.name}
                      {/* {site.name} ({site._id}) */}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>

        <Row
          gutter={24}
          style={{ padding: '3em', paddingTop: '1em', paddingBottom: '0em' }}
        >
          {/* Email */}
          <Col span={6}>
            <FormItem label="Email">
              {this.props.form.getFieldDecorator('email', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.email
                  : '',
                rules: [{ required: true, message: 'Email is required' }]
              })(
                <Input
                  type="email"
                  placeholder="Enter your email"
                  size="large"
                />
              )}
            </FormItem>
          </Col>

          {/* Full Name */}
          <Col xs={24} md={6}>
            <FormItem
              hasFeedback
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Name"
            >
              {this.props.form.getFieldDecorator('firstName', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.firstName
                  : '',
                rules: [{ required: true, message: 'Name is required' }]
              })(<Input placeholder="Enter your full name" size="large" />)}
            </FormItem>
          </Col>
          <Col xs={24} md={6}>
            <FormItem
              hasFeedback
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Last Name"
            >
              {this.props.form.getFieldDecorator('lastName', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.lastName
                  : '',
                rules: [{ required: true, message: 'Last name is required' }]
              })(<Input placeholder="Enter your last name" size="large" />)}
            </FormItem>
          </Col>

          {/* Room Number */}
          <Col span={6}>
            <FormItem label="Room Name/Number">
              {this.props.form.getFieldDecorator('roomNumber', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.roomNumber
                  : '',
                rules: [{ required: true, message: 'Room is required' }]
              })(<Input placeholder="Enter your room name or number" size="large" />)}
            </FormItem>
          </Col>
        </Row>

        <Row
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '1em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          {/* Arrival Date */}
          <Col span={6}>
            <FormItem label="Arrival Date">
              {this.props.form.getFieldDecorator('arrivalDate', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.arrivalDate)
                  : null,
                rules: [{ required: true, message: 'Arrival date is required' }]
              })(<DatePicker style={{ width: '100%' }} size="large" />)}
            </FormItem>
          </Col>

          {/* Departure Date */}
          <Col span={6}>
            <FormItem label="Departure Date">
              {this.props.form.getFieldDecorator('departureDate', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.departureDate)
                  : null,
                rules: [
                  { required: true, message: 'Departure date is required' }
                ]
              })(<DatePicker style={{ width: '100%' }} size="large" />)}
            </FormItem>
          </Col>
        </Row>

        {/* Ratings Section */}
        <Row
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '0em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          {[
            {
              label: 'Efficiency and Friendliness of the Staff',
              key: 'staffRating'
            },
            { label: 'Bar Efficiency', key: 'barService' },
            { label: 'Waiter Efficiency', key: 'waiterService' },
            { label: 'Breakfast Dining Experience', key: 'breakfastRating' },
            { label: 'Lunch Dining Experience', key: 'lunchRating' },
            { label: 'Dinner Dining Experience', key: 'dinnerRating' },
            {
              label: 'Comfort and Cleanliness (Main Areas)',
              key: 'mainAreaComfort'
            },
            { label: 'In-room Experience', key: 'inRoomExperience' },
            { label: 'Room Cleanliness', key: 'roomCleanliness' },
            { label: 'Spa Experience', key: 'spaExperience' }
          ].map(rating => (
            <Col span={6} key={rating.key} style={{ marginTop: '1em' }}>
              <FormItem label={rating.label}>
                {this.props.form.getFieldDecorator(rating.key, {
                  initialValue: this.props.editExperience
                    ? this.props.editExperience[rating.key]
                    : 0,
                  rules: [{ required: false }]
                })(
                  <RatingWithNA />
                )}
              </FormItem>
            </Col>
          ))}
        </Row>

        {/* Text Feedback Section */}
        <Row
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '1em',
            paddingBottom: '2em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          <Col span={24} style={{ marginTop: '0.5em' }}>
            <FormItem label="Most Memorable Part of Your Stay">
              {this.props.form.getFieldDecorator('memorablePart', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.memorablePart
                  : '',
                rules: [{ required: false }]
              })(
                <TextArea
                  placeholder="Describe the most memorable part of your stay"
                  rows={3}
                />
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Team Member Who Delivered Outstanding">
              {this.props.form.getFieldDecorator('outstandingService', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.outstandingService
                  : '',
                rules: [{ required: false }]
              })(<TextArea placeholder="Name the team member" rows={2} />)}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Would You Recommend Us to Family and Friends?">
              {this.props.form.getFieldDecorator('recommendation', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.recommendation
                  : null,
                rules: [{ required: false, message: 'Please select an option' }]
              })(
                <Radio.Group buttonStyle="solid" size="large">
                  <Radio.Button value="Yes">Yes</Radio.Button>
                  <Radio.Button value="No">No</Radio.Button>
                  <Radio.Button value="Maybe">Maybe</Radio.Button>
                </Radio.Group>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Comments">
              {this.props.form.getFieldDecorator('comments', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.comments
                  : '',
                rules: [{ required: false }]
              })(
                <TextArea
                  placeholder="Enter any additional comments"
                  rows={3}
                />
              )}
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}
const ExperienceForm = Form.create()(ExperienceFormClass);
class SliderFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainExperienceImage1: undefined
  };
  componentDidMount = () => {
    if (this.props.editExperience) {
      this.setState({
        mainExperienceImage1: this.props.editExperience.mainExperienceImage1
      });
    }
  };

  handleMainExperienceImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainExperienceImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === 'Add ') {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === 'Add ') {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ''
    ) {
      descriptions.push({ value: 'Add ' + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    return (
      <Form layout="vertical">
        <Row
          gutter={24}
          style={{ padding: '2em', paddingTop: 0, paddingBottom: '0em' }}
        >
          <Col span={8}>
            <FormItem label={<span>Slider Name</span>}>
              {this.props.form.getFieldDecorator('experienceNameSlider', {
                rules: [{ required: true, message: 'Site name is required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.experienceNameSlider
                  : ''
              })(<Input size="large" placeholder={'Please enter site name'} />)}
            </FormItem>
          </Col>{' '}
          <Col span={8}>
            <FormItem label={<span>Slider Decription</span>}>
              {this.props.form.getFieldDecorator(
                'experienceDescriptionSlider',
                {
                  rules: [{ required: true, message: 'Site name is required' }],
                  initialValue: this.props.editExperience
                    ? this.props.editExperience.experienceDescriptionSlider
                    : ''
                }
              )(<Input size="large" placeholder={'Please enter site name'} />)}
            </FormItem>
          </Col>{' '}
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Add products that will be showcased on this product slider">
              {this.props.form.getFieldDecorator('sliderProducts', {
                rules: [{ required: true, message: 'Supplier Name required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.sliderProducts
                  : undefined
              })(
                <Select
                  allowClear={false}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  mode="multiple"
                  size="large"
                  showSearch
                >
                  {this.props.stock.map(stock => (
                    <Option key={stock._id} value={stock._id}>
                      {stock.productTitle}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Assign categories for slider to be displayed on">
              {this.props.form.getFieldDecorator('sliderCollection', {
                rules: [{ required: true, message: 'Supplier Name required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.sliderCollection
                  : undefined
              })(
                <Select mode="multiple" size="large" showSearch>
                  <Option key={'Homepage'} value={'Homepage'}>
                    Homepage
                  </Option>
                  {this.props.sites.map(item => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}
const SliderForm = Form.create()(SliderFormClass);

class Experience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: dayjs().format('YYYY'),
      filteredExperience: [], // Filtered data for the table
      loading: false,
      closed: false,
      rejectReason: '',
      editExperience: undefined,
       siteSelected:
        this.props.user.access && this.props.user.access.length > 0
          ? String(this.props.user.access[0])
          : this.props.sites[0]
          ? String(this.props.sites[0]._id)
          : null,
      activeKey: 'Experience', // Default active key
      size: 'large',
      flag: false,
      currentTab: 'All',
      selectedMonths: [dayjs().format('MM')]
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true, selectedYear: dayjs().format('YYYY') });

    try {
      await Promise.all([
        this.fetchAllExperience(),
        this.fetchAllSites(),
        this.fetchAllUsers()
      ]);

      this.filterData();

      this.setState({ loading: false });

      window.addEventListener('resize', this.resizeEvent);

      if (window.cordova) {
        document.addEventListener('backbutton', this.handleBack);
      }
    } catch (error) {
      console.error('Error during componentDidMount:', error);
      this.setState({ loading: false });
      Notify('error', 'Error', error.message || 'An error occurred');
    }
  };

  fetchAllExperience = () => {
    const { selectedYear, siteSelected, selectedMonths } = this.state;

    return this.props
      .findAllExperience(siteSelected, selectedYear, selectedMonths)
      .catch(error => {
        throw new Error(`Error fetching experience: ${error}`);
      });
  };

  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  handleBack = () => {
    if (this.state.previewVisible) {
      this.setState({ previewVisible: false, previewVisibleVariant: false });
    } else {
      this.props.history.goBack();
    }
  };
  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  experienceForm;
  onAddExperience = e => {
    this.setState({ addExperienceVisible: true, editExperience: undefined });
  };

  onAddSlider = e => {
    this.setState({ addSliderVisible: true, editExperience: undefined });
  };

  handleMonthChange = date => {
    const selectedYear = date ? dayjs(date).format('YYYY') : null;

    this.setState({ selectedYear }, () => {
      this.fetchAllExperience().then(() => {
        this.filterData(); // ✅ Run after data and state update
      });
    });
  };

  handleAddExperience = e => {
    e.preventDefault();
    this.experienceForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.mainExperienceImage1 = this.experienceForm.state.mainExperienceImage1;
        if (this.state.editExperience) {
          values._id = this.state.editExperience._id;
        }
        this.props
          .addExperience(values)
          .then(() => {
            this.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                if (this.state.editExperience) {
                  Notify('success', 'Successfully saved');
                } else {
                  Notify('success', 'Successfully added');
                }
                this.experienceForm.props.form.resetFields();
                this.setState(
                  {
                    loading: false,
                    addExperienceVisible: false,
                    addSliderVisible: false,
                    editExperience: undefined,
                    currentTab: 'All'
                  },
                  this.filterData
                );
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleAddSlider = e => {
    e.preventDefault();
    this.sliderForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        if (this.state.editExperience) {
          values._id = this.state.editExperience._id;
        }
        this.props
          .addExperience(values)
          .then(() => {
            this.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                if (this.state.editExperience) {
                  Notify('success', 'Successfully saved');
                } else {
                  Notify('success', 'Successfully added');
                }
                this.sliderForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addExperienceVisible: false,
                  addSliderVisible: false,
                  editExperience: undefined,
                  currentTab: 'All'
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };

  handleEditExperience = e => {
    this.setState({ addExperienceVisible: true, editExperience: e });
  };
  handleEditSlider = e => {
    this.setState({ addSliderVisible: true, editExperience: e });
  };

  handleDeleteExperience = e => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data');
    const { siteSelected, selectedYear, selectedMonths } = this.state;

    Modal.confirm({
      centered: true,
      title: 'Confirm delete',
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onCancel() {
        // no-op
      },
      onOk: async () => {
        this.setState({ loading: true });
        try {
          await this.props.deleteExperience(id);

          await this.props.findAllExperience(
            siteSelected,
            selectedYear,
            selectedMonths
          );

          Notify('success', 'Successfully deleted');

          // close spinner/modal, reset tab, then re-run filterData
          this.setState(
            {
              loading: false,
              currentTab: 'All'
            },
            this.filterData
          );
        } catch (err) {
          this.setState({ loading: false });
          Notify('error', err);
        }
      }
    });
  };

  handleDeleteSlider = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteExperience(id)
          .then(() => {
            that.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                that.setState({ loading: false, currentTab: 'All' });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify('success', 'Successfully deleted');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };
  handleTabChange = key => {
    this.setState({ activeKey: key });
  };

  handleSearchName = () => {
    if (this.state.siteSelected.length > 0) {
      // this.handleSelectFocus();
      this.setState({ loading: true }); // Set loading state to true before API call
      this.props
        .findAllExperience(
          this.state.siteSelected,
          this.state.selectedYear,
          this.state.selectedMonths
        )
        .then(response => {
          const { stock, total } = response.data; // Destructure total from response
          this.setState({
            loading: false
            // stockData: stock, // Update stockData with fetched data
            // totalStock: total, // Set totalStock with the total count from the API
            // currentPage: 1, // Reset to the first page when fetching new data
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e.message);
        });
    }
  };

  exportToExcel = () => {
    const getColor = avg => {
      if (avg >= 75) return 'green';
      if (avg >= 50) return 'orange';
      return 'red';
    };

    const flatData = this.state.filteredExperience
      .sort((a, b) => dayjs(a.month, 'YYYY-MM').diff(dayjs(b.month, 'YYYY-MM')))
      .map(monthRecord => {
        // for each month we want one row per record
        return monthRecord.records.map(rec => ({
          Month: dayjs(monthRecord.month, 'YYYY-MM').format('MMM YYYY'),
          Date: rec.timestamp ? dayjs(rec.timestamp).format('YYYY-MM-DD') : '',
          Room: rec.roomNumber,
          Friendliness: rec.staffRating === 5 ? 'N/A' : (rec.staffRating * 25).toFixed(0) + '%',
          Bar: rec.barService === 5 ? 'N/A' : (rec.barService * 25).toFixed(0) + '%',
          Waiter: rec.waiterService === 5 ? 'N/A' : (rec.waiterService * 25).toFixed(0) + '%',
          Breakfast: rec.breakfastRating === 5 ? 'N/A' : (rec.breakfastRating * 25).toFixed(0) + '%',
          Lunch: rec.lunchRating === 5 ? 'N/A' : (rec.lunchRating * 25).toFixed(0) + '%',
          Dinner: rec.dinnerRating === 5 ? 'N/A' : (rec.dinnerRating * 25).toFixed(0) + '%',
          'Main Areas': rec.mainAreaComfort === 5 ? 'N/A' : (rec.mainAreaComfort * 25).toFixed(0) + '%',
          'In-room': rec.inRoomExperience === 5 ? 'N/A' : (rec.inRoomExperience * 25).toFixed(0) + '%',
          Cleanliness: rec.roomCleanliness === 5 ? 'N/A' : (rec.roomCleanliness * 25).toFixed(0) + '%',
          Spa: rec.spaExperience === 5 ? 'N/A' : (rec.spaExperience * 25).toFixed(0) + '%',
          memorablePart: rec.memorablePart,
          outstandingService: rec.outstandingService,
          recommendation: rec.recommendation,
          comments: rec.comments
        }));
      })
      .flat();

    const ws = XLSX.utils.json_to_sheet(flatData);
    const range = XLSX.utils.decode_range(ws['!ref']);
    // 0) set custom column widths
    ws['!cols'] = [
      { wch: 12 }, // Month
      { wch: 12 }, // Date
      { wch: 8 }, // Room
      { wch: 14 }, // Friendliness
      { wch: 8 }, // Bar
      { wch: 8 }, // Waiter
      { wch: 10 }, // Breakfast
      { wch: 6 }, // Lunch
      { wch: 6 }, // Dinner
      { wch: 12 }, // Main Areas
      { wch: 10 }, // In-room
      { wch: 12 }, // Cleanliness
      { wch: 8 }, // Spa
      { wch: 50 }, // Cleanliness
      { wch: 50 }, // Cleanliness
      { wch: 50 }, // Cleanliness
      { wch: 50 } // Cleanliness
    ];
    // 1) style header row black
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[cell]) continue;
      ws[cell].s = {
        fill: { fgColor: { rgb: '000000' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    }

    // 2) build a lookup of header→column index
    const headerMap = {};
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const hdrCell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (ws[hdrCell] && ws[hdrCell].v) headerMap[ws[hdrCell].v] = C;
    }

    // 3) define your color‐map and rating fields
    const colorMap = {
      green: '00FF00',
      orange: 'FFA500',
      red: 'FF0000'
    };
    const ratingFields = [
      'Friendliness',
      'Bar',
      'Waiter',
      'Breakfast',
      'Lunch',
      'Dinner',
      'Main Areas',
      'In-room',
      'Cleanliness',
      'Spa',
      'Memorable',
      'Service',
      'Recommendation',
      'Comments'
    ];

    // 4) iterate over each data row (r = 1..range.e.r)
    for (let r = range.s.r + 1; r <= range.e.r; ++r) {
      ratingFields.forEach(field => {
        const c = headerMap[field];
        if (c == null) return; // column not present?
        const addr = XLSX.utils.encode_cell({ r, c });
        const cell = ws[addr];
        if (!cell || !cell.v) return; // no value
        // strip the "%" and parse the number
        const num = parseInt(String(cell.v).replace('%', ''), 10);
        const colName = getColor(num); // "green"|"orange"|"red"
        const hex = colorMap[colName];
        // apply a background fill
        cell.s = {
          ...cell.s,
          fill: { fgColor: { rgb: hex } }
        };
      });
    }

    // 5) pack & write workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, 'report.xlsx', { bookType: 'xlsx', cellStyles: true });
  };

  groupExperienceData = experienceData => {
    const groupedData = experienceData.reduce((acc, item) => {
      const monthKey = dayjs(item.timestamp).format('YYYY-MM');

      if (!acc[monthKey]) {
        acc[monthKey] = {
          month: monthKey,
          numberOfCards: 0,
          records: [],
          staffRatingSum: 0, staffRatingCount: 0,
          barServiceSum: 0, barServiceCount: 0,
          waiterServiceSum: 0, waiterServiceCount: 0,
          breakfastRatingSum: 0, breakfastRatingCount: 0,
          lunchRatingSum: 0, lunchRatingCount: 0,
          dinnerRatingSum: 0, dinnerRatingCount: 0,
          mainAreaComfortSum: 0, mainAreaComfortCount: 0,
          inRoomExperienceSum: 0, inRoomExperienceCount: 0,
          roomCleanlinessSum: 0, roomCleanlinessCount: 0,
          spaExperienceSum: 0, spaExperienceCount: 0,
        };
      }

      // Only include values 1-4; skip 0/null and 5 (N/A)
      const addRating = field => {
        const val = item[field];
        if (val && val > 0 && val < 5) {
          acc[monthKey][field + 'Sum'] += val;
          acc[monthKey][field + 'Count']++;
        }
      };
      addRating('staffRating');
      addRating('barService');
      addRating('waiterService');
      addRating('breakfastRating');
      addRating('lunchRating');
      addRating('dinnerRating');
      addRating('mainAreaComfort');
      addRating('inRoomExperience');
      addRating('roomCleanliness');
      addRating('spaExperience');

      acc[monthKey].numberOfCards++;
      acc[monthKey].records.push(item);
      return acc;
    }, {});

    return Object.values(groupedData).map(month => {
      const avg = (sum, count) => (count > 0 ? sum / count : 0);
      const fieldAvgs = [
        avg(month.staffRatingSum, month.staffRatingCount),
        avg(month.barServiceSum, month.barServiceCount),
        avg(month.waiterServiceSum, month.waiterServiceCount),
        avg(month.breakfastRatingSum, month.breakfastRatingCount),
        avg(month.lunchRatingSum, month.lunchRatingCount),
        avg(month.dinnerRatingSum, month.dinnerRatingCount),
        avg(month.mainAreaComfortSum, month.mainAreaComfortCount),
        avg(month.inRoomExperienceSum, month.inRoomExperienceCount),
        avg(month.roomCleanlinessSum, month.roomCleanlinessCount),
        avg(month.spaExperienceSum, month.spaExperienceCount),
      ].filter(v => v > 0);
      const totalAvgScore =
        fieldAvgs.length > 0
          ? fieldAvgs.reduce((s, v) => s + v, 0) / fieldAvgs.length
          : 0;

      return {
        ...month,
        staffRatingAvg: avg(month.staffRatingSum, month.staffRatingCount),
        barServiceAvg: avg(month.barServiceSum, month.barServiceCount),
        waiterServiceAvg: avg(month.waiterServiceSum, month.waiterServiceCount),
        breakfastRatingAvg: avg(month.breakfastRatingSum, month.breakfastRatingCount),
        lunchRatingAvg: avg(month.lunchRatingSum, month.lunchRatingCount),
        dinnerRatingAvg: avg(month.dinnerRatingSum, month.dinnerRatingCount),
        mainAreaComfortAvg: avg(month.mainAreaComfortSum, month.mainAreaComfortCount),
        inRoomExperienceAvg: avg(month.inRoomExperienceSum, month.inRoomExperienceCount),
        roomCleanlinessAvg: avg(month.roomCleanlinessSum, month.roomCleanlinessCount),
        spaExperienceAvg: avg(month.spaExperienceSum, month.spaExperienceCount),
        totalAvgScore,
      };
    });
  };

  filterData = () => {
    const { siteSelected } = this.state;
    const { experience } = this.props;

    const filteredExperience = experience.filter(item => {
      // Only filter by site (access), since month is handled server-side
      return siteSelected ? item.access === siteSelected : true;
    });

    const groupedExperienceData = this.groupExperienceData(filteredExperience);

    this.setState({ filteredExperience: groupedExperienceData });
  };

  qrRef = createRef();
  downloadQRCode = () => {
    const canvas = this.qrRef.current;
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = url;
      link.download = 'QRCode.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('QR code canvas not found.');
    }
  };
  render() {
    const {
      activeKey,
      size,
      selectedYear,
      selectedDepartment,
      selectedResponsible,
      selectedStatus
    } = this.state;
    const qrCodeValue = `https://www.sproutmanagement.africa/rating/${this.state
      .siteSelected || 'default-site-id'}`;

    let descriptions = this.props.experience.map(experience => {
      return { value: experience.description };
    });
    const { experience } = this.props;
    let currentExperience;
    const filteredExperience = this.props.experience
      .filter(item => {
        const timestamp = item.timestamp
          ? dayjs(item.timestamp, 'YYYY-MM-DD')
          : null;

        const matchesMonth = selectedYear
          ? timestamp && timestamp.format('YYYY-MM') === selectedYear
          : true; // Match year and month

        const matchesDepartment = selectedDepartment
          ? item.actionDepartment === selectedDepartment
          : true;

        const matchesResponsible = selectedResponsible
          ? item.actionResponsible === selectedResponsible
          : true;

        const matchesStatus = selectedStatus
          ? item.actionStatus === selectedStatus
          : true;

        const matchesSite = this.state.siteSelected
          ? item.access === this.state.siteSelected
          : true; // Ensure the item matches the selected site

        return (
          matchesMonth &&
          matchesDepartment &&
          matchesResponsible &&
          matchesStatus &&
          matchesSite
        );
      })
      .sort((a, b) => {
        const dateA = a.timestamp
          ? dayjs(a.timestamp, 'YYYY-MM-DD')
          : dayjs.invalid();
        const dateB = b.timestamp
          ? dayjs(b.timestamp, 'YYYY-MM-DD')
          : dayjs.invalid();

        // Handle invalid dates (push them to the end)
        if (!dateA.isValid() && !dateB.isValid()) return 0;
        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;

        // Sort by date in ascending order (earliest first)
        return dateA.diff(dateB);
      });

    const getColor = avg => {
      if (avg >= 75) return 'green';
      if (avg >= 50) return 'orange';
      return 'red';
    };

    const groupExperienceData = experienceData => {
      const groupedData = this.props.experience.reduce((acc, item) => {
        const monthKey = dayjs(item.timestamp, 'YYYY-MM-DD').format('YYYY-MM');
        if (!acc[monthKey]) {
          acc[monthKey] = {
            month: monthKey,
            staffRatingAvg: 0,
            barServiceAvg: 0,
            waiterServiceAvg: 0,
            breakfastRatingAvg: 0,
            lunchRatingAvg: 0,
            dinnerRatingAvg: 0,
            mainAreaComfortAvg: 0,
            inRoomExperienceAvg: 0,
            roomCleanlinessAvg: 0,
            spaExperienceAvg: 0,
            totalAvgScore: 0,
            numberOfCards: 0,
            records: [] // Add this to store individual records
          };
        }

        // Accumulate values for each field
        acc[monthKey].staffRatingAvg += item.staffRating || 0;
        acc[monthKey].barServiceAvg += item.barService || 0;
        acc[monthKey].waiterServiceAvg += item.waiterService || 0;
        acc[monthKey].breakfastRatingAvg += item.breakfastRating || 0;
        acc[monthKey].lunchRatingAvg += item.lunchRating || 0;
        acc[monthKey].dinnerRatingAvg += item.dinnerRating || 0;
        acc[monthKey].mainAreaComfortAvg += item.mainAreaComfort || 0;
        acc[monthKey].inRoomExperienceAvg += item.inRoomExperience || 0;
        acc[monthKey].roomCleanlinessAvg += item.roomCleanliness || 0;
        acc[monthKey].spaExperienceAvg += item.spaExperience || 0;

        // Calculate total score (sum of all categories)
        acc[monthKey].totalAvgScore +=
          (item.staffRating || 0) +
          (item.barService || 0) +
          (item.waiterService || 0) +
          (item.breakfastRating || 0) +
          (item.lunchRating || 0) +
          (item.dinnerRating || 0) +
          (item.mainAreaComfort || 0) +
          (item.inRoomExperience || 0) +
          (item.roomCleanliness || 0) +
          (item.spaExperience || 0);

        acc[monthKey].numberOfCards++; // Increment the count
        acc[monthKey].records.push(item); // Add record to the group

        return acc;
      }, {});

      // Calculate averages and format as array
      return Object.values(groupedData).map(month => {
        const cardCount = month.numberOfCards;

        return {
          ...month,
          staffRatingAvg: month.staffRatingAvg / cardCount,
          barServiceAvg: month.barServiceAvg / cardCount,
          waiterServiceAvg: month.waiterServiceAvg / cardCount,
          breakfastRatingAvg: month.breakfastRatingAvg / cardCount,
          lunchRatingAvg: month.lunchRatingAvg / cardCount,
          dinnerRatingAvg: month.dinnerRatingAvg / cardCount,
          mainAreaComfortAvg: month.mainAreaComfortAvg / cardCount,
          inRoomExperienceAvg: month.inRoomExperienceAvg / cardCount,
          roomCleanlinessAvg: month.roomCleanlinessAvg / cardCount,
          spaExperienceAvg: month.spaExperienceAvg / cardCount,
          totalAvgScore: month.totalAvgScore / (10 * cardCount) // Average score across 10 categories
        };
      });
    };

    const groupedExperienceData = groupExperienceData(filteredExperience);

    // Aggregated values calculation
    const calculateAverages = (data, fields) => {
      const result = {};
      fields.forEach(field => {
        const total = data.reduce((sum, item) => sum + (item[field] || 0), 0);
        const count = data.filter(item => item[field] !== undefined).length;
        result[field] = count > 0 ? ((total * 25) / count).toFixed(0) : 'N/A';
      });
      return result;
    };

    // Fields to calculate averages for
    const ratingFields = [
      'staffRatingAvg',
      'barServiceAvg',
      'waiterServiceAvg',
      'breakfastRatingAvg',
      'lunchRatingAvg',
      'dinnerRatingAvg',
      'mainAreaComfortAvg',
      'inRoomExperienceAvg',
      'roomCleanlinessAvg',
      'spaExperienceAvg',
      'totalAvgScore'
    ];
    const fieldTitleMap = {
      staffRatingAvg: 'Friendliness',
      barServiceAvg: 'Bar',
      waiterServiceAvg: 'Waiter',
      breakfastRatingAvg: 'Breakfast',
      lunchRatingAvg: 'Lunch',
      dinnerRatingAvg: 'Dinner',
      mainAreaComfortAvg: 'Main Areas',
      inRoomExperienceAvg: 'In-room',
      roomCleanlinessAvg: 'Cleanliness',
      spaExperienceAvg: 'Spa',
      totalAvgScore: 'Avg Score'
    };

    // Calculate averages for the filtered data
    const averages = calculateAverages(
      this.state.filteredExperience,
      ratingFields
    );
   const selectedSite = this.props.sites.find(
      site => site._id === this.state.siteSelected
    );
    const props = this.props.collapsed;
    const accessList = (this.props.user?.access || []).map(String);
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Spin spinning={this.state.loading}>
          {this.state.addExperienceVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: '75em',
                    fontSize: '20px',
                    fontWeight: 800,
                    whiteSpace: 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editExperience ? 'Edit Card' : 'Add Card'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: '16px',
                      whiteSpace: 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editExperience
                      ? 'Complete all required fields and click Save to publish'
                      : 'Complete all required fields and click Save to publish'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <ExperienceForm
                  sites={this.props.sites}
                  siteSelected={this.state.siteSelected}
                  stock={this.props.stock}
                  descriptions={descriptions}
                  editExperience={this.state.editExperience}
                  wrappedComponentRef={form => (this.experienceForm = form)}
                />{' '}
                <FloatButton.Group
                  trigger="hover"
                  type="primary"
                  style={{
                    right: 24
                  }}
                  icon={<RocketFilled />}
                >
                  <Tooltip placement="left" title="Save Item">
                    <FloatButton
                      onClick={this.handleAddExperience}
                      icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                    />
                  </Tooltip>
                  <Tooltip placement="left" title="Cancel">
                    <FloatButton
                      onClick={e =>
                        this.setState({ addExperienceVisible: false })
                      }
                      icon={<StopFilled style={{ color: 'red' }} />}
                    />
                  </Tooltip>
                </FloatButton.Group>
              </div>
            </Cards>
          ) : this.state.addSliderVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: '75em',
                    fontSize: '20px',
                    fontWeight: 800,
                    whiteSpace: 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editExperience ? 'Edit Slider' : 'Add Slider'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: '16px',
                      whiteSpace: 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editExperience
                      ? "Complete all fields and click 'Save' to showcase your slider"
                      : 'Present Your Products with an Engaging Product Slider'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <SliderForm
                  sites={this.props.sites}
                  stock={this.props.stock}
                  descriptions={descriptions}
                  editExperience={this.state.editExperience}
                  wrappedComponentRef={form => (this.sliderForm = form)}
                />{' '}
                <FloatButton.Group
                  trigger="hover"
                  type="primary"
                  style={{
                    right: 24
                  }}
                  icon={<RocketFilled />}
                >
                  <Tooltip placement="left" title="Save Item">
                    <FloatButton
                      onClick={this.handleAddSlider}
                      icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                    />
                  </Tooltip>
                  <Tooltip placement="left" title="Cancel">
                    <FloatButton
                      onClick={e => this.setState({ addSliderVisible: false })}
                      icon={<StopFilled style={{ color: 'red' }} />}
                    />
                  </Tooltip>
                </FloatButton.Group>
              </div>
            </Cards>
          ) : (
            <>
              <Row>
                {' '}
                <Col span={24}>
                  <h1
                    style={{
                      float: 'left',
                      marginBottom: '0em',
                      marginRight: '1em',
                      fontSize: '22px',
                      fontWeight: 800,
                      fontFamily: 'Nunito',
                      marginTop: '0.3em'
                    }}
                  >
                    Guest Experience
                  </h1>
                  <Button
                    type="primary"
                    style={{
                      float: 'right',
                      backgroundColor: 'black',
                      marginTop: '0.3em'
                    }}
                    onClick={this.exportToExcel}
                  >
                    <DownloadOutlined />
                  </Button>
                  <Button
                    type="primary"
                    onClick={this.onAddExperience}
                    icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                    size="large"
                    style={{ float: 'right', marginRight: '0.7em' }}
                  >
                    Add Card
                  </Button>
                  <QRCodeCanvas
                    value={qrCodeValue}
                    size={350}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                    level={'H'}
                    includeMargin={true}
                    ref={this.qrRef}
                    style={{ display: 'none' }}
                  />

                  <Button
                    type="primary"
                    icon={<QrcodeOutlined />}
                    size="large"
                    onClick={this.downloadQRCode}
                    style={{ width: 100, float: 'right', marginRight: '0.7em' }}
                  >
                    QR
                  </Button>
                  {/* Month Picker */}
                  <Select
                    // mode="multiple"
                    placeholder="Select Months"
                    size="large"
                    value={this.state.selectedMonths}
                    onChange={selectedMonths => {
                      if (selectedMonths.length === 0) {
                        message.warning(
                          'At least one month must remain selected.'
                        );
                        return;
                      }

                      this.setState(
                        { selectedMonths, loading: true },
                        async () => {
                          await this.fetchAllExperience();
                          this.filterData();
                          this.setState({ loading: false });
                        }
                      );
                    }}
                    style={{ width: 300, float: 'right', marginRight: '1em' }}
                  >
                    {Array.from({ length: 12 }, (_, i) => {
                      const monthValue = this.state.selectedYear
                        ? `${String(i + 1).padStart(2, '0')}`
                        : '';

                      return (
                        <Select.Option key={monthValue} value={monthValue}>
                          {dayjs()
                            .month(i)
                            .format('MMMM')}
                        </Select.Option>
                      );
                    })}
                  </Select>

                  <DatePicker
                    picker="year"
                    placeholder="Select Year"
                    format="YYYY"
                    value={
                      this.state.selectedYear
                        ? dayjs(this.state.selectedYear, 'YYYY')
                        : null
                    }
                    onChange={date => {
                      const selectedYear = date
                        ? dayjs(date).format('YYYY')
                        : null;
                      this.setState(
                        {
                          selectedYear,
                          selectedMonths: [dayjs().format('MM')]
                        },
                        () => {
                          this.fetchAllExperience().then(() =>
                            this.filterData()
                          );
                        }
                      );
                    }}
                    allowClear={false}
                    size="large"
                    style={{ width: 100, float: 'right', marginRight: '1em' }}
                  />

                    <Select
                    size="large"
                    value={this.state.siteSelected} // Bind selected value to state
                    showSearch
                    onChange={value => {
                      this.setState({ siteSelected: value }, () => {
                        this.fetchAllExperience().then(() => this.filterData());
                      });
                    }}
                    style={{
                      marginRight: '1em',
                      width: '12em',
                      float: 'right'
                    }}
                    placeholder="Select Company"
                    optionFilterProp="children"
                  >
                    {/* <Select.Option key="Admin" value="Admin">
                                      Admin
                                    </Select.Option> */}
                    {(this.props.sites || [])
                      .filter(site => accessList.includes(String(site._id)))
                      .map(site => (
                        <Select.Option key={site._id} value={String(site._id)}>
                          {site.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: '1em' }}>
                {Object.entries(averages).map(([field, value]) => (
                  <Tag
                    color={value === 'N/A' ? 'default' : getColor(value)}
                    key={field}
                    style={{ fontSize: 14, padding: 6, marginTop: '0.5em' }}
                  >
                    {fieldTitleMap[field] || field}: {value}{value !== 'N/A' ? '%' : ''}
                  </Tag>
                ))}
              </Row>
              <Row>
                <Col span={24}>
                  <StyledTable
                    bordered={false}
                    dataSource={this.state.filteredExperience.sort((a, b) => {
                      const dateA = dayjs(a.month, 'YYYY-MM');
                      const dateB = dayjs(b.month, 'YYYY-MM');

                      // Handle invalid dates
                      if (!dateA.isValid() && !dateB.isValid()) return 0;
                      if (!dateA.isValid()) return 1;
                      if (!dateB.isValid()) return -1;

                      return dateA.diff(dateB); // Ascending order
                    })}
                    rowKey="month"
                    size="middle"
                    pagination={false}
                    style={{
                      minWidth: '15em',
                      marginTop: '1em'
                    }}
                    expandable={{
                      expandedRowRender: record => (
                        <StyledTable
                          bordered={false}
                          dataSource={record.records.sort((a, b) => {
                            const dateA = a.timestamp
                              ? dayjs(a.timestamp, 'YYYY-MM-DD')
                              : null;
                            const dateB = b.timestamp
                              ? dayjs(b.timestamp, 'YYYY-MM-DD')
                              : null;

                            // Handle invalid or null dates
                            if (!dateA && !dateB) return 0;
                            if (!dateA) return 1;
                            if (!dateB) return -1;

                            return dateA.diff(dateB); // Ascending order
                          })}
                          rowKey="_id"
                          size="small"
                          pagination={false}
                        >
                          {/* Columns for individual records */}
                          <Column
                            title="Date"
                            dataIndex="timestamp"
                            key="timestamp"
                            render={text =>
                              text
                                ? dayjs(text).format('YYYY-MM-DD')
                                : 'No Date'
                            } // Format date as "YYYY-MM-DD"
                          />
                          {/* <Column title="Full Name" dataIndex="fullName" key="fullName" /> */}
                          <Column
                            title="Room Number"
                            dataIndex="roomNumber"
                            key="roomNumber"
                          />
                          <Column
                            title="Friendliness"
                            dataIndex="staffRating"
                            key="staffRating"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Bar"
                            dataIndex="barService"
                            key="barService"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Waiter"
                            dataIndex="waiterService"
                            key="waiterService"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Breakfast"
                            dataIndex="breakfastRating"
                            key="breakfastRating"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Lunch"
                            dataIndex="lunchRating"
                            key="lunchRating"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Dinner"
                            dataIndex="dinnerRating"
                            key="dinnerRating"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Main Areas"
                            dataIndex="mainAreaComfort"
                            key="mainAreaComfort"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="In-room"
                            dataIndex="inRoomExperience"
                            key="inRoomExperience"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Cleanliness"
                            dataIndex="roomCleanliness"
                            key="roomCleanliness"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Spa"
                            dataIndex="spaExperience"
                            key="spaExperience"
                            render={text =>
                              text === 5 ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>
                            }
                          />
                          <Column
                            title="Avg. Score"
                            key="avgScore"
                            render={(_, exp) => {
                              const metrics = [
                                'staffRating', 'barService', 'waiterService',
                                'breakfastRating', 'lunchRating', 'dinnerRating',
                                'mainAreaComfort', 'inRoomExperience',
                                'roomCleanliness', 'spaExperience'
                              ];
                              const valid = metrics.filter(f => exp[f] && exp[f] > 0 && exp[f] < 5);
                              if (!valid.length) return <Tag>N/A</Tag>;
                              const avgPercent = (valid.reduce((s, f) => s + exp[f], 0) / valid.length) * 25;
                              return <Tag color={getColor(avgPercent)}>{avgPercent.toFixed(0)}%</Tag>;
                            }}
                          />
                          <Column
                            title="Actions"
                            render={(text, experience) => (
                              <span>
                                <EditFilled
                                  style={{
                                    backgroundColor: '#80CE90',
                                    color: 'white',
                                    padding: '0.5em',
                                    borderRadius: '3em'
                                  }}
                                  onClick={e =>
                                    this.handleEditExperience(experience)
                                  }
                                />
                                <Divider type="vertical" />
                                <Tooltip placement="top" title="Delete Sale">
                                  <DeleteFilled
                                    style={{
                                      backgroundColor: 'crimson',
                                      color: 'white',
                                      padding: '0.5em',
                                      borderRadius: '3em'
                                    }}
                                    data={experience._id}
                                    onClick={this.handleDeleteExperience}
                                  />
                                </Tooltip>
                              </span>
                            )}
                          />
                        </StyledTable>
                      )
                    }}
                  >
                    <Column
                      title="Month"
                      dataIndex="month"
                      key="month"
                      render={month => dayjs(month).format('MMM YYYY')}
                    />
                    <Column
                      title="Friendliness"
                      dataIndex="staffRatingAvg"
                      key="staffRatingAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Bar"
                      dataIndex="barServiceAvg"
                      key="barServiceAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Waiter"
                      dataIndex="waiterServiceAvg"
                      key="waiterServiceAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Breakfast"
                      dataIndex="breakfastRatingAvg"
                      key="breakfastRatingAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Lunch"
                      dataIndex="lunchRatingAvg"
                      key="lunchRatingAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Dinner"
                      dataIndex="dinnerRatingAvg"
                      key="dinnerRatingAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Main Areas"
                      dataIndex="mainAreaComfortAvg"
                      key="mainAreaComfortAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="In-room"
                      dataIndex="inRoomExperienceAvg"
                      key="inRoomExperienceAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Cleanliness"
                      dataIndex="roomCleanlinessAvg"
                      key="roomCleanlinessAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Spa"
                      dataIndex="spaExperienceAvg"
                      key="spaExperienceAvg"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Total Avg Score"
                      dataIndex="totalAvgScore"
                      key="totalAvgScore"
                      render={text => !text ? <Tag>N/A</Tag> : <Tag color={getColor(text * 25)}>{(text * 25).toFixed(0)}%</Tag>}
                    />
                    <Column
                      title="Number of Cards"
                      dataIndex="numberOfCards"
                      key="numberOfCards"
                    />
                  </StyledTable>
                </Col>
              </Row>
            </>
          )}
        </Spin>
      </div>
    );
  }
}

const WrappedExperience = Form.create()(Experience);
export default WrappedExperience;
